var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.6803 18.3201C79.6736 16.3064 77.2891 14.7086 74.6636 13.6184C72.0381 12.5282 69.2232 11.967 66.3803 11.967C63.5375 11.967 60.7226 12.5282 58.0971 13.6184C55.4715 14.7086 53.0871 16.3064 51.0803 18.3201L48.0003 21.4401L44.9203 18.3201C42.9136 16.3064 40.5291 14.7086 37.9036 13.6184C35.2781 12.5282 32.4632 11.967 29.6203 11.967C26.7775 11.967 23.9626 12.5282 21.3371 13.6184C18.7115 14.7086 16.3271 16.3064 14.3203 18.3201C5.84035 26.8001 5.32034 41.1201 16.0003 52.0001L48.0003 84.0001L80.0003 52.0001C90.6803 41.1201 90.1603 26.8001 81.6803 18.3201Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeart;